const DEDUP_WINDOW_MS = 500;
const CLEANUP_INTERVAL_MS = 5000;

export class EventDeduplicator {
  private recentEvents = new Map<string, number>();
  private cleanupTimer: ReturnType<typeof setInterval> | null = null;

  isDuplicate(eventName: string, payload: Record<string, unknown>): boolean {
    const dedupKey = eventName + '|' + JSON.stringify(payload);
    const now = Date.now();
    const lastSent = this.recentEvents.get(dedupKey);

    if (lastSent !== undefined && now - lastSent < DEDUP_WINDOW_MS) {
      return true;
    }

    this.recentEvents.set(dedupKey, now);
    return false;
  }

  start(): void {
    if (this.cleanupTimer) return;
    this.cleanupTimer = setInterval(() => {
      const now = Date.now();
      for (const [key, timestamp] of this.recentEvents) {
        if (now - timestamp > DEDUP_WINDOW_MS) {
          this.recentEvents.delete(key);
        }
      }
    }, CLEANUP_INTERVAL_MS);
  }

  destroy(): void {
    if (this.cleanupTimer) {
      clearInterval(this.cleanupTimer);
      this.cleanupTimer = null;
    }
    this.recentEvents.clear();
  }
}
